import React, { useRef } from "react";
import PageBanner from "../../containers/global/page-banner";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";
import Layout from "../../layouts/index";
import ServiceProviderData from "../../data/customer-support.json";
import CustomerSupportContainer from "../../containers/customer-service/customer-support";
import ServiceProviderAddressContainer from "../../containers/customer-service/customer-support-address";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";

const CustomerSupportPage = () => {
    const contRef = useRef(null);
    const handleScrollToHeader = () => {
        console.log("scrllheader", contRef);
        if (contRef.current) {
            console.log("scrllheader2");
            // Adjust scrolling to account for the height of the small div
            const headerPosition = contRef.current.offsetTop;
            const divHeight = 0; // Adjust this if your div's height changes
            window.scrollTo({
                top: headerPosition,
                behavior: "smooth",
            });
        }
    };
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Customer Support | NeoGrowth - Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header
                        onPressSkipButton={() => {
                            handleScrollToHeader();
                        }}
                    />
                    <PageBanner
                        title="Customer Support"
                        excerpt=""
                        image="/images/banner/page/neoinsights.png"
                    />
                    <CustomerSupportContainer
                        contRef={contRef}
                        mainData={ServiceProviderData[0]["contactUs"]}
                    />

                    <ServiceProviderAddressContainer
                        contRef={contRef}
                        mainData={ServiceProviderData[1]["branch"][0]}
                    />

                    <ServiceProviderAddressContainer
                        contRef={contRef}
                        mainData={ServiceProviderData[1]["branch"][1]}
                    />

                    <ServiceProviderAddressContainer
                        contRef={contRef}
                        mainData={ServiceProviderData[1]["branch"][2]}
                    />

                    <ServiceProviderAddressContainer
                        contRef={contRef}
                        mainData={ServiceProviderData[1]["branch"][3]}
                    />

                    <ServiceProviderAddressContainer
                        contRef={contRef}
                        mainData={ServiceProviderData[1]["branch"][4]}
                    />

                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default CustomerSupportPage;
